import React from "react";

const FromWidget = ({ company, name }) => {
  return (
    <div className="grid">
      <span>{company}</span>
      <span className={`text-[${company ? 12 : 16}px]`}>{name}</span>
    </div>
  );
};

export default FromWidget;
